<template>
  <v-row>
    <v-col cols="12">
      <ContentHeader />
    </v-col>
    <v-col cols="12">
      <Catalog v-if="id == 'catalog'" />
      <Pages v-else-if="id == 'pages'" />
      <Questions v-else-if="id == 'questions'" />
      <Authors v-else-if="id == 'authors' && is_admin" />
      <Images v-else-if="id == 'images' && is_admin" />
      <AddPage />
    </v-col>
  </v-row>
</template>

<script>
import AddPage from '@/components/content/AddPage';
import Authors from '@/components/content/Authors';
import Catalog from '@/components/content/catalog/List';
import ContentHeader from '@/components/content/Header';
import Images from '@/components/content/Images';
import Pages from '@/components/content/pages/Index';
import Questions from '@/components/content/questions/Index';
import { mapGetters } from 'vuex';
export default {
  name: 'ContentDetail',
  components: {
    ContentHeader,
    Catalog,
    Pages,
    Questions,
    Authors,
    Images,
    AddPage
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ...mapGetters({ is_admin: 'auth/is_admin' })
  },
  watch: {
    id(val, oldVal) {
      if (val !== oldVal && !val) {
        this.$router.push('/content/pages');
      }
    }
  },
  async mounted() {
    if (!this.id) {
      this.$router.push('/content/pages');
    } else {
      await Promise.all([
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getDesignGroups'),
        this.$store.dispatch('lookup/getDesigners'),
        this.$store.dispatch('lookup/getProducts'),
        this.$store.dispatch('lookup/getIndustries'),
        this.$store.dispatch('lookup/getTopics')
      ]);
    }
  }
};
</script>
